<ng-dialog-header title="Waybill Details"></ng-dialog-header>
<mat-dialog-content class="h-100">
  <div #printContainer *ngIf="!loading; else loadingMask">
    <div class="w-100">
      <h1 class="text-center">NORFOLK SOUTHERN <br> TRANSPORTATION WAYBILL</h1>
      <div class="text-right">
        <button mat-icon-button aria-label="Print Waybill" (click)="printWaybill()">
          <mat-icon fontIcon="fa-file-pdf" fontSet="fas"></mat-icon>
        </button>
      </div>
    </div>
    <div class="w-100 d-flex">
      <div class="w-50 float-left">
        <strong>** NS SERIAL: {{ waybill?.nsSerialNumber }}</strong>
      </div>
      <div class="w-50 float-right text-right">
        <strong>IMAGE ID.: {{ waybill?.imageId }}</strong>
      </div>
    </div>
    <div class="border p-2 m-2">
      <div class="row">
        <div class="col-2 col-lg-2 col-sm-6">
          <div><strong>Car initial & No</strong></div>
          <div>{{ waybill?.carId }}</div>
        </div>
        <div class="col-1 col-lg-1 col-sm-6">
          <div><strong>Kind</strong></div>
          <div>{{ waybill?.kind }}</div>
        </div>
        <div class="col-2 col-lg-2 col-sm-6">
          <div><strong>Trailer initial & No</strong></div>
          <div>{{ waybill?.trailerCarId }}</div>
        </div>
        <div class="col-1 col-lg-1 col-sm-6">
          <div><strong>Length</strong></div>
          <div>{{ waybill?.length }}</div>
        </div>
        <div class="col-1 col-lg-1 col-sm-6">
          <div><strong>Plan</strong></div>
          <div>{{ waybill?.planNumber }}</div>
        </div>
        <div class="col-1 col-lg-1 col-sm-6">
          <div><strong>Length of Car</strong></div>
          <div>{{ waybill?.carFurnishedInsideLength }}</div>
        </div>
        <div class="col-2 col-lg-2 col-sm-6">
          <div><strong>Waybill Date</strong></div>
          <div>{{ waybill?.waybillDate | date:'MM/dd/yyyy' }}</div>
        </div>
        <div class="col-2 col-lg-2 col-sm-6">
          <div><strong>Waybill Number</strong></div>
          <div>{{ waybill?.waybillNumber }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-6 col-lg-6 col-sm-12">
          <div><strong>Car Transferred To</strong></div>
        </div>
        <div class="col-2 col-lg-2 col-sm-6">
          <div><strong>Capacity of Car Ordered</strong></div>
          <div>{{ waybill?.carOrderedCapacity }}</div>
        </div>
        <div class="col-1 col-lg-1 col-sm-6">
          <div><strong>Furnished</strong></div>
          <div>{{ waybill?.carFurnishedCapacity }}</div>
        </div>
        <div class="col-1 col-lg-1 col-sm-6">
          <div><strong>Version</strong></div>
          <div>{{ waybill?.waybillVersionNumber }}</div>
        </div>
        <div class="col-1 col-lg-1 col-sm-6">
          <div><strong>Time</strong></div>
          <div>{{ waybill?.waybillTime | date:'hh:mm a' }}</div>
        </div>
        <div class="col-1 col-lg-1 col-sm-6">
          <div><strong>By</strong></div>
          <div>{{ waybill?.billingClerkInitial }}</div>
        </div>
      </div>
    </div>
    <div class="border p-2 m-2">
      <div class="row">
        <div class="col-3 col-lg-3 col-sm-6">
          <strong>Station No.</strong>
        </div>
        <div class="col-3 col-lg-3 col-sm-6">
          <strong>Station</strong>
        </div>
        <div class="col-3 col-lg-3 col-sm-6">
          <strong>State</strong>
        </div>
        <div class="col-3 col-lg-3 col-sm-6">
          <strong>For Consignee at Stop</strong>
        </div>
      </div>
      <div class="row" *ngFor="let stop of waybill?.stopOffStations">
        <div class="col-3 col-lg-3 col-sm-6">
          {{ stop.stationNumber }}
        </div>
        <div class="col-3 col-lg-3 col-sm-6">
          {{ stop.station }}
        </div>
        <div class="col-3 col-lg-3 col-sm-6">
          {{ stop.state }}
        </div>
        <div class="col-3 col-lg-3 col-sm-6">
          {{ stop.forConsignee }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6 col-lg-6 col-md-12">
        <div class="border p-2 m-2">
          <div class="row">
            <div class="col-2">
              <div><strong>To Station No.</strong></div>
              <div>{{ waybill?.toStationNumber }}</div>
            </div>
            <div class="col-5">
              <div><strong>Station</strong></div>
              <div>{{ waybill?.toStationCity }}</div>
            </div>
            <div class="col-5">
              <div><strong>State</strong></div>
              <div>{{ waybill?.toState }}</div>
            </div>
          </div>
        </div>
        <div class="border p-2 m-2">
          <div class="row">
            <div class="col-2">
              <div><strong>Route</strong></div>
              <div *ngFor="let route of waybill?.routeDetails">{{ route.road }} {{ route.junction }}</div>
            </div>
            <div class="col-5">
              <div><strong>A/S/R</strong></div>
              <div>{{ waybill?.agentShipperRoute }}</div>
            </div>
            <div class="col-5">
              <div><strong>Rte Code</strong></div>
              <div>{{ waybill?.routeCode }}</div>
            </div>
          </div>
        </div>
        <div class="border p-2 m-2">
          <div class="row">
            <div class="col-6">
              <div><strong>Consignee & Address</strong></div>
              <div>{{ waybill?.consigneeName }}</div>
              <div>{{ waybill?.consigneeAddress1 }}</div>
              <div>{{ waybill?.consigneeAddress2 }}</div>
            </div>
            <div class="col-6">
              <div><strong>Customer Code</strong></div>
              <div>{{ waybill?.consigneeCode }}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div><strong>Consignee Order Number</strong></div>
              <div>{{ waybill?.consigneeOrderNumber }}</div>
            </div>
          </div>
        </div>
        <div class="border p-2 m-2">
          <div class="row">
            <div class="col-12">
              <div><strong>Final Destination</strong></div>
              <div>{{ waybill?.finalDestState }}</div>
            </div>
          </div>
        </div>
        <div class="border p-2 m-2">
          <div class="row">
            <div class="col-12">
              <strong>Special Instructions</strong>
            </div>
          </div>
          <div class="row" *ngFor="let instruction of waybill?.specialInstructions">
            <div class="col-12">{{ instruction }}</div>
          </div>
        </div>
        <div class="border p-2 m-2">
          <div class="row">
            <div class="col-12">
              <strong>Additional Info/Reconsignment</strong>
            </div>
          </div>
          <div class="row" *ngFor="let additionalInformation of waybill?.additionalInformation">
            <div class="col-12">{{ additionalInformation }}</div>
          </div>
          <div class="row">
            <div class="col-12">
              <div><strong>Purchase Order Number</strong></div>
              <div>{{ waybill?.purchaseOrderNumber }}</div>
            </div>
          </div>
        </div>
        <div class="border p-2 m-2">
          <div class="row">
            <div class="col-2 text-right">
              <strong>Contract SYS</strong>
            </div>
            <div class="col-10">
              {{ waybill?.contractNumberSystem }}
            </div>
          </div>
          <div class="row">
            <div class="col-2 text-right">
              <strong>FGN</strong>
            </div>
            <div class="col-10">
              {{ waybill?.contractNumberFGN }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 col-lg-6 col-md-12">
        <div class="border p-2 m-2">
          <div class="row">
            <div class="col-3 offset-3">
              <strong>Station No.</strong>
            </div>
            <div class="col-3">
              <strong>Station</strong>
            </div>
            <div class="col-3">
              <strong>State</strong>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <strong>Origin</strong>
            </div>
            <div class="col-3">
              {{ waybill?.originStationNumber }}
            </div>
            <div class="col-3">
              {{ waybill?.originStationCity }}
            </div>
            <div class="col-3">
              {{ waybill?.originState }}
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <strong>Billed At</strong>
            </div>
            <div class="col-3">
              {{ waybill?.billingStationNumber }}
            </div>
            <div class="col-3">
              {{ waybill?.billingCity }}
            </div>
            <div class="col-3">
              {{ waybill?.billingState }}
            </div>
          </div>
        </div>
        <div class="border p-2 m-2">
          <div class="row">
            <div class="col-6">
              <div><strong>Full Name of Shipper & Address</strong></div>
              <div>{{ waybill?.shipperAddress1 || '' }}</div>
              <div>{{ waybill?.shipperAddress2 || '' }}</div>
              <div>{{ waybill?.shipperAddress3 || '' }}</div>
              <div>{{ waybill?.shipperAddress4 || '' }}</div>
            </div>
            <div class="col-6">
              <div><strong>Customer Code</strong></div>
              <div>{{ waybill?.shipperCode }}</div>
            </div>
          </div>
        </div>
        <div class="border p-2 m-2">
          <div class="row">
            <div class="col-3">
              <strong>RWC</strong>
            </div>
            <div class="col-3">
              <strong>Shpr. Bill of Lading</strong>
            </div>
            <div class="col-3">
              <div><strong>Date</strong></div>
              <div>{{ waybill?.billOfLadingDate | date:'MM/dd/yyyy' }}</div>
            </div>
            <div class="col-3">
              <div><strong>Number</strong></div>
              <div>{{ waybill?.billOfLadingNumber }}</div>
            </div>
          </div>
        </div>
        <div class="border p-2 m-2">
          <div class="row">
            <div class="col-12">
              <div><strong>Previous Waybill Reference</strong></div>
              <div>{{ waybill?.originalWaybillXrefWaybillNumber }}</div>
            </div>
          </div>
        </div>
        <div class="border p-2 m-2">
          <div class="row">
            <div class="col-6">
              <div><strong>Bill To Party</strong></div>
              <div>{{ waybill?.billToPartyAddress1 || '' }}</div>
              <div>{{ waybill?.billToPartyAddress2 || '' }}</div>
              <div>{{ waybill?.billToPartyAddress3 || '' }}</div>
              <div>{{ waybill?.billToPartyAddress4 || '' }}</div>
            </div>
            <div class="col-6">
              <div><strong>Customer Code</strong></div>
              <div>{{ waybill?.billToPartyCustomerNumber }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6 col-md-6 col-sm-12">
            <div class="border p-2 m-2">
              <div class="row">
                <div class="col-6">
                  <div><strong>PPD/COL</strong></div>
                  <div>{{ waybill?.collectPrepaidText }}</div>
                </div>
                <div class="col-6">
                  <div><strong>Section 7</strong></div>
                  <div>{{ waybill?.section7IndicatorText }}</div>
                </div>
              </div>
            </div>
            <div class="border p-2 m-2">
              <div class="row">
                <div class="col-6">
                  <div><strong>Rev. Date</strong></div>
                  <div>{{ waybill?.revenueDate | date:'MM/dd/yyyy' }}</div>
                </div>
                <div class="col-6">
                  <div><strong>Time</strong></div>
                  <div>{{ waybill?.waybillTime | date:'hh:mm a' }}</div>
                </div>
              </div>
            </div>
            <div class="border p-2 m-2">
              <div class="row">
                <div class="col-6">
                  <strong>Declared Value</strong>
                </div>
                <div class="col-6">
                  {{ waybill?.declaredValue }}
                </div>
              </div>
            </div>
            <div class="border p-2 m-2">
              <div class="row">
                <div class="col-12">
                  <strong>Explanation of Rate Symbols</strong>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  N=next ton G=gross ton P=per unit C=CWT
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-6 col-sm-12">
            <div class="border p-2 m-2">
              <div class="row">
                <div class="col-6">
                  <strong>Weighted At</strong>
                </div>
                <div class="col-6">
                  {{ waybill?.weighedAtCity }}
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <strong>GROSS</strong>
                </div>
                <div class="col-6">
                  {{ waybill?.totalGross }}
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <strong>TARE</strong>
                </div>
                <div class="col-6">
                  {{ waybill?.totalTare }}
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <strong>ALLOWANCE</strong>
                </div>
                <div class="col-6">
                  {{ waybill?.weightAllowance }}
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <strong>NET</strong>
                </div>
                <div class="col-6">
                  {{ waybill?.totalNetWeight }}
                </div>
              </div>
            </div>
            <div class="border p-2 m-2">
              <div class="row">
                <div class="col-12">
                  <strong>Tarriff Authority</strong>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  {{ waybill?.tarriffAuthority }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="border p-2 m-2">
      <div class="row">
        <div class="col-3 col-lg-3 col-sm-6">
          <div><strong>Commodity Code</strong></div>
          <div>{{ waybill?.commodityCode }}</div>
        </div>
        <div class="col-3 col-lg-3 col-sm-6">
          <div><strong>Mine No.</strong></div>
          <div>{{ waybill?.mineNumber }}</div>
        </div>
        <div class="col-3 col-lg-3 col-sm-6">
          <div><strong>Mine Name</strong></div>
          <div>{{ waybill?.mineName }}</div>
        </div>
        <div class="col-3 col-lg-3 col-sm-6">
          <strong>Date Tagged</strong>
        </div>
      </div>
    </div>
    <div class="border p-2 m-2">
      <div class="row">
        <div class="col-2 col-lg-2 col-sm-6">
          <strong>Pkgs</strong>
        </div>
        <div class="col-2 col-lg-2 col-sm-6">
          <strong>Qual</strong>
        </div>
        <div class="col-4 col-lg-4 col-sm-6">
          <strong>Description of Articles</strong>
        </div>
        <div class="col-2 col-lg-2 col-sm-6">
          <strong>W/Q</strong>
        </div>
        <div class="col-2 col-lg-2 col-sm-6">
          <strong>Weight</strong>
        </div>
      </div>
      <div class="row" *ngFor="let ladingEntry of waybill?.landingEntries">
        <div class="col-2 col-lg-2 col-sm-6">
          {{ ladingEntry.packageLanding }}
        </div>
        <div class="col-2 col-lg-2 col-sm-6">
          {{ ladingEntry.quality }}
        </div>
        <div class="col-4 col-lg-4 col-sm-6">
          {{ ladingEntry.description }}
        </div>
        <div class="col-2 col-lg-2 col-sm-6">
          {{ ladingEntry.w || '' }} {{ ladingEntry.q || '' }}
        </div>
        <div class="col-2 col-lg-2 col-sm-6">
          {{ ladingEntry.weight }}
        </div>
      </div>
    </div>
    <div *ngIf="(waybill?.wayBills || []).length > 0" class="border p-2 m-2">
      <div class="p-2">
        <strong>Waybills</strong>
      </div>
      <ns-grid [name]="gridConfigs.gridName"
               [gridTitle]="gridConfigs.gridTitle"
               [config]="gridConfigs.headerOptions"
               [data]="waybill?.wayBills || []"
               [columns]="gridConfigs.columns"
               [loading]="loading"
               [gridOptions]="gridConfigs.options"
      ></ns-grid>
    </div>
  </div>
</mat-dialog-content>
<ng-dialog-footer>
  <div dialog-actions class="d-flex justify-content-end w-100">
    <button mat-stroked-button color="warn" aria-label="close" mat-dialog-close>Close</button>
  </div>
</ng-dialog-footer>
<ng-template #loadingMask>
  <ns-skeleton [type]="skeleton"></ns-skeleton>
</ng-template>
